import { useQuery, useQueryClient } from 'react-query';

import { type IListing } from 'src/services/api/listings/types';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';

type IGetListingsOptions = {
    isMatched?: boolean;
    propertyId?: number;
    status?: 'active' | 'inactive';
    page?: number;
    pageSize?: number;
    disabled?: boolean;
    refetchInterval?: number;
};

export type IGetListingsResponse = { [key: string]: IListing[] };

const GET_LISTINGS_PATH = 'api/landlord/listings/';

export const useListings = (options?: IGetListingsOptions) => {
    const queryClient = useQueryClient();

    return useQuery(
        [queryKeys.listings, { isMatched: options?.isMatched, propertyId: options?.propertyId, status: options?.status ?? 'active', page: options?.page, pageSize: options?.pageSize }],
        async () => {
            const searchParams = new URLSearchParams();
            if (options?.propertyId) {
                searchParams.set('property_id', String(options.propertyId));
            }
            if (options?.isMatched !== undefined) {
                searchParams.set('is_matched', String(options.isMatched));
            }
            searchParams.set('status', options?.status ?? 'active');
            if (options?.page !== undefined) {
                searchParams.set('page', String(options.page));
            }
            if (options?.pageSize !== undefined) {
                searchParams.set('page_size', String(options.pageSize));
            }
            const res = await apiClient(GET_LISTINGS_PATH, {
                searchParams,
            }).json<IGetListingsResponse>();
            return res;
        },
        {
            enabled: !options?.disabled,
            keepPreviousData: true,
            refetchInterval: options?.refetchInterval,
            onSuccess: (data) => {
                for (const listings of Object.values(data)) {
                    for (const listing of listings) {
                        queryClient.setQueryData([queryKeys.listings, listing.id], listing);
                    }
                }
            },
        }
    );
};
